<template>
  <BaseModal
    name="prelink-cupom"
    size="md"
    :title="$t('seller.coupon.pre_link.text_273')"
    @hidden="reset"
  >
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <section class="container-prelink" v-else>
      <p>
        {{ $t('seller.coupon.pre_link.text_274') }}
      </p>
      <b-form novalidate class="mt-3">
        <b-form-group :label="$t('seller.coupon.pre_link.text_2482')" label-for="product_id">
          <multiselect
            id="ajax"
            label="name"
            track-by="id"
            v-model="data.produto"
            :placeholder="$t('seller.coupon.pre_link.text_1827')"
            :selectLabel="$t('seller.coupon.pre_link.text_1828')"
            :deselectLabel="$t('seller.coupon.pre_link.text_1829')"
            selectedLabel="✔️"
            open-direction="bottom"
            :options="products"
            :multiple="false"
            :searchable="true"
            :loading="loading_product"
            :internal-search="false"
            :clear-on-select="false"
            :close-on-select="true"
            :options-limit="10"
            :show-no-results="true"
            :hide-selected="true"
            @search-change="aux_product_debounce"
          >
            <span slot="noOptions">{{ $t('seller.coupon.pre_link.text_1830') }}</span>

            <span slot="noResult"
              >{{ $t('seller.coupon.pre_link.text_1831') }}</span
            >
          </multiselect>
          <b-form-invalid-feedback :state="!errors.has('product_id')">
            {{ $t('seller.coupon.pre_link.text_1832') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <!-- cupom -->
        <b-form-group
          :label="$t('seller.coupon.pre_link.text_275')"
          label-for="cupom_id"
          v-if="data.produto"
        >
          <multiselect
            data-anima="top"
            v-model="data.cupom"
            :placeholder="$t('seller.coupon.pre_link.text_1833')"
            label="name"
            track-by="id"
            :options="cupons"
            :multiple="false"
            :taggable="false"
          >
            <span slot="noOptions">{{ $t('seller.coupon.pre_link.text_276') }}</span>

            <span slot="noResult">{{ $t('seller.coupon.pre_link.text_277') }}</span>
          </multiselect>
          <b-form-invalid-feedback :state="!errors.has('cupom_id')">
            {{ $t('seller.coupon.pre_link.text_278') }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-form>
    </section>

    <template v-slot:footer="{ cancel }">
      <BaseButton
        variant="secondary_outline"
        :disabled="loading"
        @click="cancel"
        class="mr-4"
      >
        {{ $t('seller.coupon.pre_link.text_1834') }}
      </BaseButton>

      <div id="redirect-link">
        <BaseButton
          variant="link-info"
          :disabled="loading || !data.produto || !data.cupom"
          @click="redirectLink"
        >
          {{ $t('seller.coupon.pre_link.text_1835') }}
        </BaseButton>
      </div>

      <b-tooltip
        v-if="!data.produto || !data.cupom"
        target="redirect-link"
        :title="$t('seller.coupon.pre_link.text_2483')"
      />
    </template>
  </BaseModal>
</template>

<script>
import ProductService from "@/services/resources/ProductService";
const serviceProduct = ProductService.build();

import CouponService from "@/services/resources/CouponService";
const serviceCoupon = CouponService.build();

import Multiselect from "vue-multiselect";
import _ from "lodash";
export default {
  props: ["productRead"],
  name: "PreLink",
  data() {
    return {
      loading: false,
      loading_product: false,
      products: [],
      cupons: [],
      data: {
        produto: null,
        cupom: null,
      },
    };
  },
  components: {
    Multiselect,
  },
  watch: {
    "data.produto"(value) {
      this.getCupom(value.id);
    },
  },
  methods: {
    reset() {
      this.products = [];
      this.cupons = [];
      this.data = {
        produto: null,
        cupom: null,
      };
    },
    redirectLink() {
      const produto = this.data.produto;
      const cupom = this.data.cupom;
      // this.$router.push(
      //   `/cupom/?c_id=${cupom.id}&c_name=${cupom.name}&p_id=${produto.id}&p_name=${produto.name}&p_type=${produto.type}`
      // );
      this.$bvModal.hide("prelink-cupom");
      this.$emit("emitLink", { cupom: cupom, produto: produto });
    },
    // produto
    aux_product_debounce(query) {
      this.loading_product = true;
      this.search = query;
      this.debounce_product();
    },
    debounce_product: _.debounce(function() {
      this.fetchProducts(this.search);
    }, 500),

    fetchProducts(search = null) {
      let data = {
        list: true,
      };

      if (search) data.search = search;

      this.products = [];

      serviceProduct
        .search(data)
        .then((response) => {
          response.forEach((element) => {
            this.products.push({
              id: element.id,
              name: element.name,
              type: element.type,
            });
          });
        })
        .catch((err) => {
          console.log(err);
          this.products = [];
        })
        .finally(() => {
          this.loading_product = false;
        });
    },
    getCupom(product_id) {
      this.loading = true;

      let data = {
        id: `product/${product_id}`,
      };

      this.cupons = [];

      serviceCoupon
        .read(data)
        .then((response) => {
          console.log(response);
          response.forEach((el) => {
            this.cupons.push({
              id: el.id,
              name: el.name,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.container-prelink p {
  margin: 0;
  font-size: 14px;
  font-weight: normal;
  color: #81858e;
  line-height: 1.5;
}
</style>
